import Api from './api';

const insurancesListRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/insurances', {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createInsuranceRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/insurances/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteInsuranceRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/insurances/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { insurancesListRequest, createInsuranceRequest, deleteInsuranceRequest }



// WEBPACK FOOTER //
// ./src/api/apiInsurance.js